<app-filter-card
  i18n-heading
  heading="Artikelfilter"
  testId="product-filter"
  [canReset]="isFiltered"
  (reset)="resetFilter()"
>
  <div class="col-12 col-md-3">
    <label for="filterName" class="form-label" i18n>Name</label>
    <input
      id="filterName"
      data-testid="product-filter-name-input"
      class="form-control"
      type="text"
      [(ngModel)]="searchWord"
      (input)="searchThis()"
    />
  </div>

  <div class="col-12 col-md-3">
    <label for="filterCategory" class="form-label" i18n>Kategorie</label>
    <kendo-dropdownlist
      id="filterCategory"
      class="w-100"
      data-testid="product-filter-category-dropdown"
      [data]="productCategories"
      [defaultItem]="defaultItem"
      [(ngModel)]="productCategoryId"
      textField="name"
      valueField="id"
      [valuePrimitive]="true"
      (selectionChange)="productCategoryChange($event)"
    >
    </kendo-dropdownlist>
  </div>

  <div class="col-12 col-md-3">
    <!-- Spacer label so this column matches the label+control structure of
         the Name/Kategorie columns; hidden on stacked (mobile) layout. -->
    <label class="form-label d-none d-md-block" aria-hidden="true">&nbsp;</label>
    <div class="d-flex align-items-center gap-3" style="min-height: var(--ts-control-height)">
      <div class="form-check mb-0">
        <input
          id="filterActive"
          class="form-check-input"
          data-testid="product-filter-active-checkbox"
          type="checkbox"
          [(ngModel)]="isActive"
          (change)="searchThis()"
          kendoCheckBox
        />
        <label for="filterActive" class="form-check-label" i18n>Aktive</label>
      </div>
      <div class="form-check mb-0">
        <input
          id="filterInactive"
          class="form-check-input"
          data-testid="product-filter-inactive-checkbox"
          type="checkbox"
          [(ngModel)]="isInactive"
          (change)="searchThis()"
          kendoCheckBox
        />
        <label for="filterInactive" class="form-check-label" i18n>Inaktive</label>
      </div>
    </div>
  </div>
</app-filter-card>
